import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirditempotraveller() {



    const cardData = {

keyword: "Pune to Shirdi Tempo Traveller",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Shirdi Tempo Traveller services for family groups, pilgrimages, and spiritual tours. We provide well-maintained 13, 14, and 17-seater AC Tempo Travellers with push-back seats, ample luggage space, and experienced chauffeurs for smooth highway travel. With doorstep pickup across Pune, Pune Airport to Shirdi transfers, one-way and round-trip options, 24/7 support, and transparent pricing, we ensure a peaceful and hassle-free Sai Baba darshan journey for all passengers.",

topPlaces: [
    {
        title: "Shri Sai Baba Samadhi Mandir, Shirdi",
        description:
            "Shri Sai Baba Samadhi Mandir is the main spiritual attraction in Shirdi and one of the most visited pilgrimage sites in India. Devotees from across the country come here for Sai Baba’s darshan, blessings, and spiritual peace. The temple complex is well-organized, with long queues managed smoothly and a deeply devotional atmosphere throughout the day."
    },
    {
        title: "Dwarkamai Masjid",
        description:
            "Dwarkamai Masjid is a sacred place where Sai Baba lived for many years. It houses the holy dhuni (sacred fire), which is believed to have healing and wish-fulfilling powers. This site reflects Sai Baba’s teachings of faith, patience, and compassion, making it a must-visit spiritual location in Shirdi."
    },
    {
        title: "Chavadi",
        description:
            "Chavadi is a historically important site in Shirdi where Sai Baba used to sleep on alternate nights. It preserves his belongings and offers a peaceful environment for devotees to experience his simple lifestyle and spiritual legacy."
    },
    {
        title: "Lendi Baug",
        description:
            "Lendi Baug is a serene garden maintained in memory of Sai Baba, where he used to water plants daily. It is considered a peaceful and sacred space, offering devotees a calm environment for reflection and spiritual connection."
    },
    {
        title: "Shani Shingnapur Temple",
        description:
            "Shani Shingnapur is a famous nearby pilgrimage destination dedicated to Lord Shani, known for its unique tradition of doorless houses. It is often included in Shirdi travel itineraries as an important spiritual extension for devotees."
    },
    {
        title: "Sai Heritage Village",
        description:
            "Sai Heritage Village is a cultural attraction that showcases the life, miracles, and teachings of Sai Baba through themed setups and displays. It helps visitors understand the spiritual journey of Sai Baba in an interactive way."
    },
    {
        title: "Wet N Joy Water Park",
        description:
            "Wet N Joy Water Park near Shirdi is a popular entertainment destination offering water rides, slides, and family fun activities. It is often visited by groups after darshan for relaxation and enjoyment."
    },
    {
        title: "Nashik & Trimbakeshwar Route",
        description:
            "Nashik and Trimbakeshwar are important spiritual destinations near Shirdi, known for Jyotirlinga darshan, Godavari ghats, and temples. Many travelers extend their Shirdi trip for a complete pilgrimage circuit from Pune."
    },
    {
        title: "Ahmednagar Highway Route",
        description:
            "The Pune to Shirdi route via Ahmednagar is smooth and commonly used for pilgrimage travel. It offers comfortable driving conditions, food stops, and a safe highway experience, making Tempo Traveller journeys easy and convenient."
    },
    {
        title: "Sai Baba Mandir Complex Surroundings",
        description:
            "The area around the Sai Baba Mandir includes devotional shops, prayer halls, and accommodation facilities for pilgrims. The environment remains highly spiritual and active throughout the year with continuous devotee movement."
    }
],



services: [
  {
    name: "Pune to Shirdi Tempo Traveller on Rent",
    description: "Rising Cab Service offers Pune to Shirdi Tempo Traveller on Rent for comfortable group travel, Sai Baba darshan tours, family pilgrimages, and corporate religious trips. Our Tempo Travellers are equipped with spacious seating, air conditioning, ample luggage space, and experienced chauffeurs. Enjoy safe and hassle-free travel with doorstep pickup, flexible schedules, transparent pricing, and 24x7 customer support. We ensure a comfortable pilgrimage experience for groups of all sizes traveling from Pune to Shirdi."
  },
  {
    name: "Pune Airport to Shirdi Tempo Traveller on Rent",
    description: "Book Pune Airport to Shirdi Tempo Traveller on Rent for direct airport pickup and seamless transfer to Shirdi. Our professional drivers track flight schedules, provide timely pickups, and ensure comfortable travel in clean and well-maintained AC Tempo Travellers suitable for family groups and pilgrims."
  },
  {
    name: "Pune to Shirdi Tempo Traveller AC 13 & 17 Seater",
    description: "Choose Pune to Shirdi Tempo Traveller AC 13 & 17 Seater options for comfortable and spacious group travel. Our AC vehicles feature pushback seats, ample legroom, and professional drivers, making them ideal for pilgrimage tours and family trips."
  },
  {
    name: "Pune to Shirdi Mini Bus Rent",
    description: "Pune to Shirdi Mini Bus Rent service is ideal for larger groups seeking economical and comfortable transportation. Our mini buses are maintained to high safety standards and provide smooth travel for darshan tours and group pilgrimages."
  },
  {
    name: "Bus Hire for Pune to Shirdi",
    description: "Hire a Bus for Pune to Shirdi with Rising Cab Service for family groups, corporate tours, and religious gatherings. We provide spacious seating, professional drivers, and affordable travel packages for a comfortable journey."
  },
  {
    name: "Pune Airport to Shirdi Tempo Traveller",
    description: "Our Pune Airport to Shirdi Tempo Traveller service offers direct transfers from the airport to Shirdi with flexible pickup schedules, comfortable seating, and reliable transportation support."
  },
  {
    name: "Pune to Shani Shingnapur Tempo Traveller",
    description: "Book Pune to Shani Shingnapur Tempo Traveller for convenient group travel to the famous pilgrimage destination. Enjoy safe transportation, experienced drivers, and comfortable travel arrangements for devotees."
  },
  {
    name: "Pune to Shani Shingnapur Bus on Rent",
    description: "Pune to Shani Shingnapur Bus on Rent provides spacious and economical transportation for pilgrim groups, family tours, and religious gatherings with comfortable seating and professional service."
  },
  {
    name: "Pune to Shirdi 14 Seater Bus on Rent",
    description: "Hire a Pune to Shirdi 14 Seater Bus on Rent for medium-sized groups seeking comfortable and affordable pilgrimage transportation. Our vehicles offer spacious seating and smooth travel."
  },
  {
    name: "Pune to Shirdi 17 Seater on Rent",
    description: "Pune to Shirdi 17 Seater on Rent is perfect for larger groups traveling together for Sai Baba darshan. Enjoy comfortable pushback seating, AC interiors, and experienced chauffeurs."
  },
  {
    name: "Pune to Ahmednagar Tempo Traveller on Rent",
    description: "Book Pune to Ahmednagar Tempo Traveller on Rent for business travel, family trips, and religious tours with comfortable seating, reliable drivers, and flexible rental packages."
  },
  {
    name: "Pune to Ajanta Ellora Tempo Traveller on Rent",
    description: "Pune to Ajanta Ellora Tempo Traveller on Rent is ideal for heritage tours, educational trips, and sightseeing journeys. Enjoy comfortable long-distance travel with professional drivers and spacious vehicles."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Pune",
    description: "17 Seater Tempo Traveller on Rent in Pune offers comfortable group transportation for pilgrimages, family vacations, corporate outings, and long-distance travel with spacious interiors and AC comfort."
  },
  {
    name: "Pune to Shirdi Tempo Traveller Package",
    description: "Pune to Shirdi Tempo Traveller Package includes pickup, drop, darshan travel, and flexible return options. Designed for families and groups, the package provides convenient and affordable pilgrimage transportation."
  },
  {
    name: "Pune to Shani Shingnapur Tempo Traveller On Rent",
    description: "Pune to Shani Shingnapur Tempo Traveller On Rent offers reliable transportation for devotees visiting Shani Shingnapur. Our service includes comfortable vehicles, experienced drivers, and flexible travel plans."
  },
  {
    name: "Pune to Shirdi Tempo Traveller",
    description: "Rising Cab Service provides Pune to Shirdi Tempo Traveller service with AC vehicles, spacious seating, and professional chauffeurs. Perfect for pilgrimage groups, family travel, and religious tours."
  },
  {
    name: "Pune to Shirdi Tempo Traveller Booking",
    description: "Pune to Shirdi Tempo Traveller Booking allows quick and hassle-free reservations with transparent pricing, instant confirmation, and 24x7 customer assistance."
  },
  {
    name: "Tempo Traveller Pune to Shirdi",
    description: "Tempo Traveller Pune to Shirdi service ensures safe and comfortable group travel with flexible pickup locations, spacious interiors, and reliable transportation support."
  },
  {
    name: "Pune to Shirdi Traveller Hire",
    description: "Pune to Shirdi Traveller Hire offers customized travel plans for family groups, pilgrimages, and corporate tours with experienced drivers and well-maintained vehicles."
  },
  {
    name: "AC Tempo Traveller Pune to Shirdi",
    description: "AC Tempo Traveller Pune to Shirdi provides fully air-conditioned travel with comfortable seating and smooth transportation, ensuring a pleasant pilgrimage experience in all seasons."
  },
  {
    name: "Luxury Tempo Traveller Pune to Shirdi",
    description: "Luxury Tempo Traveller Pune to Shirdi offers premium interiors, pushback seats, spacious cabins, and enhanced comfort for VIP pilgrims, corporate groups, and luxury travelers."
  },
  {
    name: "17 Seater Tempo Traveller Pune to Shirdi",
    description: "17 Seater Tempo Traveller Pune to Shirdi is designed for larger groups seeking safe, comfortable, and affordable pilgrimage transportation with professional chauffeur service."
  },
  {
    name: "13 Seater Tempo Traveller Pune to Shirdi",
    description: "13 Seater Tempo Traveller Pune to Shirdi is ideal for medium-sized groups, families, and devotees looking for comfortable and economical travel to Shirdi."
  },
  {
    name: "Cheap Tempo Traveller Pune to Shirdi",
    description: "Cheap Tempo Traveller Pune to Shirdi offers budget-friendly group transportation without compromising comfort, safety, or service quality. Perfect for cost-conscious travelers."
  },
  {
    name: "Tempo Traveller for Shirdi Darshan",
    description: "Tempo Traveller for Shirdi Darshan provides complete transportation solutions for Sai Baba devotees with comfortable travel, flexible schedules, and professional driver support."
  },
  {
    name: "Outstation Tempo Traveller Pune to Shirdi",
    description: "Outstation Tempo Traveller Pune to Shirdi offers reliable long-distance transportation with spacious seating, experienced drivers, and customized travel plans for pilgrimage groups."
  },
  {
    name: "Tempo Traveller on Rent Pune to Shirdi",
    description: "Tempo Traveller on Rent Pune to Shirdi provides convenient and affordable rental options for family trips, religious tours, and group travel with well-maintained vehicles."
  },
  {
    name: "Pune to Shirdi Group Travel Tempo Traveller",
    description: "Pune to Shirdi Group Travel Tempo Traveller is specially designed for large families, friends, and pilgrimage groups seeking safe and comfortable transportation together."
  },
  {
    name: "Pune to Shirdi Tour Tempo Traveller",
    description: "Pune to Shirdi Tour Tempo Traveller offers complete travel packages including pickup, darshan transportation, and return journeys with reliable service and professional drivers."
  },
  {
    name: "One Way Tempo Traveller Pune to Shirdi",
    description: "One Way Tempo Traveller Pune to Shirdi provides economical drop-only transportation for travelers needing flexible travel schedules and affordable pilgrimage travel."
  },
  {
    name: "Pune to Shirdi Urbania on Rent",
    description: "Pune to Shirdi Urbania on Rent offers premium group transportation with luxury seating, spacious interiors, modern amenities, and superior comfort for pilgrimage and leisure travel."
  }
],

tableData: [
  ["Pune to Shirdi Tempo Traveller on Rent", "Pune Airport to Shirdi Tempo Traveller on Rent"],
  ["Pune to Shirdi Tempo Traveller AC 13 & 17 Seater", "Pune to Shirdi Mini Bus Rent"],
  ["Bus Hire for Pune to Shirdi", "Pune Airport to Shirdi Tempo Traveller"],
  ["Pune to Shani Shingnapur Tempo Traveller", "Pune to Shani Shingnapur Bus on Rent"],
  ["Pune to Shirdi 14 Seater Bus on Rent", "Pune to Shirdi 17 Seater on Rent"],
  ["Pune to Ahmednagar Tempo Traveller on Rent", "Pune to Ajanta Ellora Tempo Traveller on Rent"],
  ["17 Seater Tempo Traveller on Rent in Pune", "Pune to Shirdi Tempo Traveller Package"],
  ["Pune to Shani Shingnapur Tempo Traveller On Rent", "Pune to Shirdi Tempo Traveller"],
  ["Pune to Shirdi Tempo Traveller Booking", "Tempo Traveller Pune to Shirdi"],
  ["Pune to Shirdi Traveller Hire", "AC Tempo Traveller Pune to Shirdi"],
  ["Luxury Tempo Traveller Pune to Shirdi", "17 Seater Tempo Traveller Pune to Shirdi"],
  ["13 Seater Tempo Traveller Pune to Shirdi", "Cheap Tempo Traveller Pune to Shirdi"],
  ["Tempo Traveller for Shirdi Darshan", "Outstation Tempo Traveller Pune to Shirdi"],
  ["Tempo Traveller on Rent Pune to Shirdi", "Pune to Shirdi Group Travel Tempo Traveller"],
  ["Pune to Shirdi Tour Tempo Traveller", "One Way Tempo Traveller Pune to Shirdi"],
  ["Pune to Shirdi Urbania on Rent", "Pune to Shirdi Tempo Traveller Package"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Shirdi Tempo Traveller Service",
        WhyChoosedescription: "Rising Cab Service provides spacious Tempo Traveller rentals from Pune to Shirdi for families, pilgrimage groups, senior citizens, corporate teams, and devotees visiting Sai Baba Temple."
    },
    {
        WhyChooseheading: "Perfect for Sai Baba Darshan Group Tours",
        WhyChoosedescription: "Our Tempo Travellers are ideal for family pilgrimages, bhajan groups, religious tours, society groups, and spiritual gatherings traveling together."
    },
    {
        WhyChooseheading: "Multiple Tempo Traveller Seating Options",
        WhyChoosedescription: "Choose from 12 Seater, 14 Seater, 17 Seater, 20 Seater, and luxury Tempo Traveller options according to your group size and travel requirements."
    },
    {
        WhyChooseheading: "Cover Shirdi and Nearby Religious Destinations",
        WhyChoosedescription: "Travelers can conveniently visit Shirdi Sai Baba Temple, Shani Shingnapur, Trimbakeshwar, Nashik, Grishneshwar, and other pilgrimage destinations."
    },
    {
        WhyChooseheading: "AC Tempo Travellers for Comfortable Pilgrimage Travel",
        WhyChoosedescription: "Our well-maintained air-conditioned Tempo Travellers provide comfortable seating, spacious interiors, and a relaxing travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Tempo Traveller pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Temple Routes",
        WhyChoosedescription: "Professional drivers familiar with pilgrimage routes ensure safe, smooth, and hassle-free travel throughout the journey."
    },
    {
        WhyChooseheading: "One-Day and Multi-Day Shirdi Tour Packages",
        WhyChoosedescription: "Customers can choose same-day Shirdi Darshan, overnight tours, weekend pilgrimage packages, and customized religious travel plans."
    }
]
};

const faqData = [
    {
        question: "Why should I hire a Tempo Traveller for a Shirdi trip?",
        answer: "Tempo Travellers provide comfortable seating, ample luggage space, and are ideal for families and groups traveling together for Sai Baba Darshan."
    },
    {
        question: "Which Tempo Traveller seating capacities are available?",
        answer: "We provide 12 Seater, 14 Seater, 17 Seater, 20 Seater, and luxury Tempo Traveller options."
    },
    {
        question: "Can Shani Shingnapur be included in the Shirdi package?",
        answer: "Yes, customized packages can include Shirdi, Shani Shingnapur, Trimbakeshwar, Nashik, and other nearby pilgrimage destinations."
    },
    {
        question: "Are AC Tempo Travellers available for Shirdi travel?",
        answer: "Yes, fully air-conditioned Tempo Travellers are available for comfortable travel throughout the journey."
    },
    {
        question: "Can we book a same-day Shirdi Darshan package?",
        answer: "Yes, same-day return Tempo Traveller packages are available for Shirdi Sai Baba Darshan."
    },
    {
        question: "Is the Tempo Traveller suitable for senior citizens?",
        answer: "Yes, the spacious seating and comfortable travel make Tempo Travellers ideal for elderly devotees and family groups."
    },
    {
        question: "Can corporate groups hire Tempo Travellers for religious tours?",
        answer: "Yes, corporate groups, societies, and organizations frequently hire Tempo Travellers for pilgrimage and group travel."
    },
    {
        question: "Are weekend Shirdi Tempo Traveller packages available?",
        answer: "Yes, weekend pilgrimage tours, overnight trips, and customized travel packages are available."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Shirdi Tempo Traveller?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sanjay Kulkarni",
        feedback:
            "Our family Shirdi pilgrimage was very comfortable with the Tempo Traveller. The vehicle was clean, spacious, and perfect for our group travel requirements.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Archana Patil",
        feedback:
            "We booked a Tempo Traveller for Shirdi and Shani Shingnapur Darshan. The journey was smooth, the driver was professional, and the entire experience was excellent.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Shirdi Tempo Traveller Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-shirdi-tempo-traveller.jpg",
"description": "Book Pune to Shirdi Tempo Traveller on Rent with Rising Cab Service for comfortable and spiritual group travel. Ideal for Shirdi Sai Baba darshan trips with AC 13, 17, and luxury tempo travellers with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹24/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-shirdi-tempo-traveller"
}
};





    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Tempo Traveller | Sai Baba Darshan Group Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Shirdi Tempo Traveller on Rent for Sai Baba darshan group travel. Comfortable AC 13 & 17 seater tempo travellers with experienced drivers for safe pilgrimage trips."
/>

<meta
 name="keywords"
 content="pune to shirdi tempo traveller, pune airport to shirdi tempo traveller, shirdi tempo traveller on rent pune, 13 seater tempo traveller shirdi, 17 seater tempo traveller shirdi, shirdi darshan tempo traveller pune, pune to shirdi group travel cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/72.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirditempotraveller;